export const wrapTooltipContent = (content, additionClass) => {
  return `<div class="text-[15px] px-4 py-2 max-w-[300px] min-w-[100px] flex justify-center items-center ${additionClass}">${content}</div>`;
};
